import React from "react";
import {
  stylesGenericInputLabelCP,
  stylesGenericInputLabelContainerTerlcel,
} from "../../../styles/genericInputLabel";

class GenericInputLabel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      titleStyles: {},
    };
  }

  componentDidMount() {
    this.updateStyles();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isContainerTelcel !== this.props.isContainerTelcel || prevProps.hasError !== this.props.hasError) {
      this.updateStyles();
    }
  }

  updateStyles() {
    const { isContainerTelcel, hasError } = this.props;
    const baseStyles = isContainerTelcel
      ? stylesGenericInputLabelContainerTerlcel
      : stylesGenericInputLabelCP;

    const wrapper = {
      ...baseStyles.wrapper,
      color: hasError ? (isContainerTelcel ? "#d32222" : "#DA291C") : "#222222",
    };

    this.setState({
      titleStyles: {
        ...baseStyles,
        wrapper,
      },
    });
  }

  render() {
    const {
      titleStyles: { wrapper, image, label },
    } = this.state;
    const { imgIcon, labelText, showIcon, handleOnClickLabelIcon, id } =
      this.props;
    return (
      <div style={wrapper}>
        <p style={label}>
          <span>{labelText}</span>
          {showIcon ? (
            <img
              src={imgIcon}
              style={image}
              onClick={(e) => handleOnClickLabelIcon(e, id)}
            />
          ) : (
            <></>
          )}
        </p>
      </div>
    );
  }
}
export default GenericInputLabel;
